"use client";

import { useMediaQuery } from "@mantine/hooks";
import { ScrollView } from "react95";
import { ThcPage } from "@/components/partners/thc/thc-page";
import MobilePage from "@/components/ui/mobile-page";

export default function Page() {
  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  return (
    <>
      {isSmallScreen === true && <MobilePage disabled={true} />}
      {isSmallScreen === false && (
        <ScrollView
          style={{
            width: "100%",
            flexGrow: "1",
            background: "#ddd",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            height: "100vh",
          }}
        >
          <ThcPage />
        </ScrollView>
      )}
    </>
  );
}
